const SESSION_LOGIN_AT_KEY = "motion.sessionLoginAt";
const LAST_SESSION_KEY = "motion.lastSession";

const toIso = (ms) => new Date(ms).toISOString();

export const formatSessionDuration = (durationMs) => {
  if (!Number.isFinite(durationMs) || durationMs < 0) {
    return "0s";
  }

  const totalSeconds = Math.floor(durationMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const parts = [];
  if (hours) parts.push(`${hours}h`);
  if (minutes || hours) parts.push(`${minutes}m`);
  parts.push(`${seconds}s`);
  return parts.join(" ");
};

export const getSessionLoginAt = () => {
  try {
    const raw = localStorage.getItem(SESSION_LOGIN_AT_KEY);
    const value = Number(raw);
    return Number.isFinite(value) && value > 0 ? value : null;
  } catch {
    return null;
  }
};

/**
 * Starts (or keeps) the current website session clock.
 * Call on successful login. Safe to call again while already logged in.
 */
export const recordSessionLogin = ({ force = false } = {}) => {
  try {
    if (!force && getSessionLoginAt()) return getSessionLoginAt();

    const loginAt = Date.now();
    localStorage.setItem(SESSION_LOGIN_AT_KEY, String(loginAt));
    return loginAt;
  } catch {
    return null;
  }
};

export const getLastSession = () => {
  try {
    const raw = localStorage.getItem(LAST_SESSION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
};

/**
 * Ends the session on logout and returns overall time on site.
 */
export const recordSessionLogout = () => {
  const loginAt = getSessionLoginAt();
  const logoutAt = Date.now();

  if (!loginAt) {
    try {
      localStorage.removeItem(SESSION_LOGIN_AT_KEY);
    } catch {
      // ignore
    }
    return null;
  }

  const durationMs = Math.max(0, logoutAt - loginAt);
  const session = {
    loginAt,
    logoutAt,
    loginAtIso: toIso(loginAt),
    logoutAtIso: toIso(logoutAt),
    durationMs,
    durationFormatted: formatSessionDuration(durationMs),
  };

  try {
    localStorage.setItem(LAST_SESSION_KEY, JSON.stringify(session));
    localStorage.removeItem(SESSION_LOGIN_AT_KEY);
  } catch {
    // ignore storage failures
  }

  return session;
};
